import React from "react";
import { func, any } from "prop-types";
import * as style from "./styles.module.scss";
import BookingsProfileSectionIcon from "../../icons/BookingsProfileSectionIcon";

const BookingsProfileSection = ({ onAddOrUpdateHandler, bookingsSection }) => {
  return (
    <div
      className={`w-100 bg-white d-flex justify-content-between p-1 ${style.profile__bookings} mb-2`}
      id="profileBookingsSection"
    >
      <div className={style.profile__bookings_title}>
        <span className="pr-1">
          <BookingsProfileSectionIcon />
        </span>
        Bookings
      </div>
      <div>
        <button
          className={`btn font-weight-bold text-dark btn-outline-info ${style.profile__bookings_button}`}
          onClick={() => onAddOrUpdateHandler(bookingsSection.taskName)}
        >
          View bookings
        </button>
      </div>
    </div>
  );
};

BookingsProfileSection.propTypes = {
  onAddOrUpdateHandler: func,
  bookingsSection: any,
};

export default BookingsProfileSection;
